import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SessionModule } from '@ansys-internal/awf-angular/auth';
import { provideUserProfileMenu } from '@ansys-internal/awf-angular/shared';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { PagesModule } from './awf-contributions/pages/pages.module';
import { TokensModule } from './tokens/tokens.module';
import { GraphQLModule } from '@ansys-internal/portal-bff-angular-client';
import { AWFConfig } from '@ansys-internal/awf-js/core';
import {
  DashboardMainTab,
  provideDashboardEntities,
} from '@ansys-internal/awf-angular/dashboard';
import { awfContributionOverrides } from './awf-contributions/awf-contribution-overrides';
import { provideDashboardDefaults } from '@ansys-internal/awf-data-providers';

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    // DashboardModule,
    CommonModule,
    BrowserAnimationsModule,
    GraphQLModule,
    SessionModule,
    PagesModule,
    TokensModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideDashboardDefaults(),
  ],
})
export class AndromedaModule {}

@AWFConfig({
  providers: [],
  imports: [
    DashboardMainTab,
    ...provideDashboardEntities(),
    ...provideUserProfileMenu(),
    ...awfContributionOverrides(),
  ],
})
export class AndromedaConfig {}
